import { createTaskRunner } from '@gonfalon/async/createTaskRunner';
import { postAccessCheckBulk } from '@gonfalon/openapi/operations/postAccessCheckBulk';
import type { schemas } from '@gonfalon/openapi/types';

import { reactQueryResponseAdapter } from './reactQueryResponseAdapter';

export type AccessCheckTask = {
  resource: string;
  action: string;
};

type Data = schemas['AccessCheckBulkResponse'][number] | undefined;

export const internalAccessCheckTaskRunner = createTaskRunner<
  AccessCheckTask,
  Data,
  schemas['AccessCheckBulkResponse']
>({
  name: 'access-check-runner',
  async runner(inputs) {
    return reactQueryResponseAdapter(
      postAccessCheckBulk({
        header: {
          Authorization: document.cookie,
        },
        service: 'gonfalon',
        body: inputs,
      }),
    );
  },
  resolver(data, input) {
    return data.find((d) => d.action === input.action && d.resource === input.resource);
  },
  batching: {
    maxBatchSize: 25,
    resultMerger(data) {
      return data.flatMap((batch) => batch);
    },
  },
});
